import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";

export function _ObtenerCalendarios(idsEscuelas: number[]) {
    const url = _APP_CONFIG.URL_RSTV2 + "calendario/ObtenerCalendarios";
    const params = {
        "IdsEscuelas": idsEscuelas,
    }
    return DataDRequest._Request5<Entidad.ICalendario[]>(url, "GET", params);
}

export default { _ObtenerCalendarios }